import { BrowserInfo } from "../models";

export namespace PaymentUtils {
  const CLIENT_KEY = 'clientKey';
  const ORIGIN_KEY = 'originKey';

  export function getEnviromentOriginKey(originKeys): string {
    const port = location.port ? `:${location.port}` : '';
    const originKey = originKeys[`${location.protocol}//${location.hostname}${port}`];

    return originKey ? originKey : originKeys[Object.keys(originKeys)[0]];
  }
  export function getKeyConfig(options): Record<string, string> {
    const clientKey = options?.clientKey;
    const originKeys = options?.originKeys;
    const hasClientKey = !!clientKey;
    return {
      [hasClientKey ? CLIENT_KEY : ORIGIN_KEY]: hasClientKey
        ? clientKey
        : PaymentUtils.getEnviromentOriginKey(originKeys || {}),
    } as const;
  }

  export function getBrowserInfo(): BrowserInfo {
    return {
      acceptHeader: '*/*',
      colorDepth: window?.screen?.colorDepth,
      javaEnabled: typeof navigator.javaEnabled === 'function' ? navigator.javaEnabled?.() : false,
      language: navigator?.language,
      screenHeight: window?.screen?.height,
      screenWidth: window?.screen?.width,
      timeZoneOffset: new Date().getTimezoneOffset(),
      userAgent: navigator?.userAgent,
    };
  }
}
